import React from 'react';
 const AddressMap=()=>{
    return (
        <div className='pt-4'>
          <iframe className='map-size' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.3485639053147!2d77.64192261476964!3d12.885293990912533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14ae711c38d1%3A0xdb0989974bf50fd3!2sMOIRA%20BUILDING%20SYSTEMS!5e0!3m2!1sen!2sin!4v1652637785908!5m2!1sen!2sin" width="600" height="450" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
        </div>
    );
 }
 export{AddressMap}